export const REASONS_KEY = 'account-closure.reasons';
